(function () {
    'use strict';

    angular
        .module('riskSelfAssessmentReviewControllers')
        .controller('RiskSelfAssessmentReviewByAssessorController', Controller);

    Controller.$inject = ['$scope', '$state', 'topBarService', 'govProcess', 'risksToReview', 'assessmentQuestions'];

    function Controller($scope, $state, topBarService, govProcess, risksToReview, assessmentQuestions) {
        topBarService.setTitleAndIcon(govProcess.DisplayName, 'fa fa-umbrella');

        if ($state.is('riskSelfAssessmentReviewByAssessor')) {
            var risk = _.find(risksToReview, function (risk) {
                return !risk.Assessment || !risk.Assessment.HasFinalAssessorReviewed;
            });

            if (_.isUndefined(risk)) {
                $state.go('riskSelfAssessmentReviewByAssessor.summary', {}, { location: 'replace' });
            } else if (assessmentQuestions && assessmentQuestions.RiskAssessmentQuestions && assessmentQuestions.RiskAssessmentQuestions.length) {
                $state.go('riskSelfAssessmentReviewByAssessor.preliminaryQuestions', {}, { location: 'replace' });
            } else {
                $state.go('riskSelfAssessmentReviewByAssessor.risk', {RiskID: risk.Risk.RiskID}, { location: 'replace' });
            }
        }
    }
})();
